import React from 'react';

export function Skeleton({ width, height = 14, radius = 4, style = {}, className = '' }) {
  return (
    <span
      className={`skeleton ${className}`}
      style={{
        display: 'inline-block',
        width: width ?? '100%',
        height,
        borderRadius: radius,
        ...style,
      }}
      aria-hidden="true"
    />
  );
}

export function SkeletonText({ lines = 3, lastWidth = '60%' }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} width={i === lines - 1 ? lastWidth : '100%'} />
      ))}
    </div>
  );
}

export function SkeletonStatCard() {
  return (
    <div className="stat-card">
      <Skeleton width="50%" height={11} style={{ marginBottom: 8 }} />
      <Skeleton width="40%" height={24} />
    </div>
  );
}

export function SkeletonStatsGrid({ count = 4 }) {
  return (
    <div className="stats-grid" style={{ marginBottom: 16 }}>
      {Array.from({ length: count }).map((_, i) => <SkeletonStatCard key={i} />)}
    </div>
  );
}

export function SkeletonTableRows({ rows = 6, cols = 4 }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, r) => (
        <tr key={r}>
          {Array.from({ length: cols }).map((_, c) => (
            <td key={c}><Skeleton width={c === 0 ? '70%' : `${50 + (c * 7) % 40}%`} /></td>
          ))}
        </tr>
      ))}
    </>
  );
}

export function SkeletonCard({ height = 120 }) {
  return (
    <div className="card" style={{ height }}>
      <Skeleton width="40%" height={16} style={{ marginBottom: 12 }} />
      <SkeletonText lines={2} />
    </div>
  );
}

export function SkeletonList({ items = 5, itemHeight = 60 }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {Array.from({ length: items }).map((_, i) => (
        <div key={i} className="card" style={{ padding: 12, height: itemHeight, display: 'flex', alignItems: 'center', gap: 12 }}>
          <Skeleton width={36} height={36} radius={18} />
          <div style={{ flex: 1 }}>
            <Skeleton width="50%" height={14} style={{ marginBottom: 6 }} />
            <Skeleton width="80%" height={11} />
          </div>
        </div>
      ))}
    </div>
  );
}

export default Skeleton;
